import { render, staticRenderFns } from "./SchoolOfMusic.vue?vue&type=template&id=2d03e9f0"
import script from "./SchoolOfMusic.vue?vue&type=script&lang=js"
export * from "./SchoolOfMusic.vue?vue&type=script&lang=js"
import style0 from "./SchoolOfMusic.vue?vue&type=style&index=0&id=2d03e9f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports